var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExaminationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52606",
    "data-name": "Group 52606",
    transform: "translate(-158 -3004.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18648",
    "data-name": "Rectangle 18648",
    transform: "translate(158 3004.968)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_19_",
    "data-name": "svgexport-7 (19)",
    transform: "translate(167.562 3010.505)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_496",
    "data-name": "Ellipse 496",
    cx: 12.644,
    cy: 12.644,
    r: 12.644,
    transform: "translate(10.911 1.25)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91039",
    "data-name": "Path 91039",
    d: "M24.626,30.1,29.9,35.372a1.79,1.79,0,0,0,2.533-2.531l-5.276-5.276A1.791,1.791,0,0,0,24.626,30.1Z",
    transform: "translate(27.995 35.781)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91040",
    "data-name": "Path 91040",
    d: "M29.633,17.059A15.037,15.037,0,1,0,44.669,32.1,15.045,15.045,0,0,0,29.633,17.059Zm0,3.581A11.456,11.456,0,1,1,18.176,32.1,11.461,11.461,0,0,1,29.633,20.64Z",
    transform: "translate(14.803 21.933)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91041",
    "data-name": "Path 91041",
    d: "M33.149,11.392a14.97,14.97,0,0,1-9.595,3.464,14.97,14.97,0,0,1-9.595-3.464A19.614,19.614,0,0,0,3.925,28.514V42.746a1.788,1.788,0,0,0,1.791,1.791h25.77a1.789,1.789,0,0,0,1.75-2.165,11.467,11.467,0,0,1,8.518-13.553,1.788,1.788,0,0,0,1.366-1.884,19.625,19.625,0,0,0-9.97-15.542ZM18.493,21.682a3.579,3.579,0,0,0-3.536,3.579v2.9a3.579,3.579,0,0,0,3.536,3.579,3.581,3.581,0,0,0,3.581,3.536h2.9a3.579,3.579,0,0,0,3.579-3.536,3.577,3.577,0,0,0,3.536-3.579v-2.9a3.577,3.577,0,0,0-3.536-3.579,3.579,3.579,0,0,0-3.579-3.536h-2.9a3.581,3.581,0,0,0-3.581,3.536Zm6.484,3.579V21.727h-2.9V25.26H18.538v2.9h3.536V31.7h2.9V28.163H28.51v-2.9Z",
    transform: "translate(0 14.071)",
    fill: "#93a750"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExaminationIcon);
export default __webpack_public_path__ + "static/media/ExaminationIcon.f96e19efec77706b7d23f33d5d93fac3.svg";
export { ForwardRef as ReactComponent };